import SimpleStore from 'src/store/SimpleStore';
import { HTTP_URL_PARAMS } from 'src/utils/constants/HttpMethodsConstants';

import { getLocalStorage, getCookie } from '../../browserStorageHandler';
import {
  GUEST_TOKEN,
  USER_TYPE,
  GLOBAL_REGION
} from '../../constants/localStorageConstants';
//  eslint-disable-next-line
import { getUserTypeForGlobal } from '../mixpanel/mixpanelHelper';
// eslint-disable-next-line
import { getUrlParamsAsObject } from '../../SubscriptionHelper/SubscriptionHelper';
import {
  MIXPANEL_NAME,
  MIXPANEL_EMAIL,
  MIXPANEL_PHONE,
  MIXPANEL_GENDER,
  MIXPANEL_DOB,
  MIXPANEL_USER_TYPE,
  MIXPANEL_REGISTRING_COUNTRY,
  MIXPANEL_STATE,
  MIXPANEL_NEW_APP_LANGUAGE,
  MIXPANEL_NEW_CONTENT_LANGUAGE,
  MIXPANEL_COUNTRY,
  MIXPANEL_ZEE5_COUNTRY,
  MIXPANEL_REGION,
  MIXPANEL_IDENTITY,
  MIXPANEL_PHOTO,
  MIXPANEL_GUEST_ID
} from '../mixpanel/mixpanelConstants';

export const clevertapObj: { [key: string]: any } = {};

let clevertapEventQueue: { [key: string]: any }[] = [];

const getClevertapGender = (gender: string) => {
  return gender === 'male' ? 'M' : 'F';
};

export const clevertapFilterMethod = (trackObject = {}) => {
  const clevertapEventObj: { [key: string]: any } = {};
  Object.entries(trackObject).forEach(([key, value]) => {
    /* Clevertap object structure will not support value as array format */
    if (Array.isArray(value)) {
      clevertapEventObj[key] = value.join();
    } else if (value === 'N/A') {
      clevertapEventObj[key] = undefined;
    } else if (key === 'token') {
      // Removing the mixpanel ID (token) from clevertap event properties
      clevertapEventObj[key] = undefined;
    } else {
      clevertapEventObj[key] = value;
    }
  });
  return clevertapEventObj;
};

export const createCleverTapUserData = (
  userData: any,
  isProfilePush = false
) => {
  const userObj = {
    ...clevertapObj.peopleProperties,
    ...clevertapObj.superProperties
  };
  const country = getCookie('country');
  userObj[MIXPANEL_NAME] =
    userData && userData.first_name ? userData.first_name : undefined;
  userObj[MIXPANEL_EMAIL] =
    userData && userData.email ? userData.email : undefined;
  if (userData && userData.mobile) {
    const mobileNumber = userData.mobile;
    userObj[MIXPANEL_PHONE] = /[+]/.test(mobileNumber)
      ? mobileNumber
      : `+${mobileNumber}`;
  } else {
    userObj[MIXPANEL_PHONE] = undefined;
  }
  userObj[MIXPANEL_GENDER] =
    userData && userData.gender
      ? getClevertapGender(userData.gender)
      : undefined;
  userObj[MIXPANEL_DOB] =
    userData && userData.birthday ? new Date(userData.birthday) : undefined;
  userObj[MIXPANEL_USER_TYPE] = getUserTypeForGlobal(
    getLocalStorage(USER_TYPE)
  );
  userObj[MIXPANEL_REGISTRING_COUNTRY] = country;
  userObj[MIXPANEL_STATE] =
    userData && userData.location && userData.location.state;
  userObj[MIXPANEL_NEW_APP_LANGUAGE] = userData && userData.displayLanguage;
  userObj[MIXPANEL_NEW_CONTENT_LANGUAGE] = userData && userData.contentLanguage;
  userObj[MIXPANEL_COUNTRY] =
    country ||
    (userData && userData.location && userData.location.country.toUpperCase());
  userObj[MIXPANEL_ZEE5_COUNTRY] =
    userData && userData.location && userData.location.country.toUpperCase();
  if (country !== 'IN') {
    userObj[MIXPANEL_REGION] = getLocalStorage(GLOBAL_REGION);
  }

  if (userData && userData.id) {
    if (!isProfilePush) {
      userObj[MIXPANEL_IDENTITY] = userData.id;
    } else {
      userObj[MIXPANEL_PHOTO] = undefined;
    }
  } else {
    userObj[MIXPANEL_GUEST_ID] = getLocalStorage(GUEST_TOKEN);
  }
  const clevertapEventObj = clevertapFilterMethod(userObj);
  return clevertapEventObj;
};

export const clevertapWebpushMethod = () => {
  if (
    typeof window !== 'undefined' &&
    window.clevertap &&
    !window.location.pathname.includes('/myaccount/subscription') &&
    !window.location.pathname.includes('/myaccount/payment') &&
    !window.location.pathname.includes('/b2b')
  ) {
    window.clevertap.notifications.push({
      titleText: 'Would you like to receive Push Notifications?',
      bodyText:
        'We promise to only send you relevant content and give you updates on your transactions',
      okButtonText: 'Sign me up!',
      rejectButtonText: 'No thanks',
      okButtonColor: '#f28046',
      hidePoweredByCT: true,
      serviceWorkerPath: `/service-worker-webapp-${process.env.APP_VERSION}.js` // path to your custom service worker file
    });
  }
};

export const clevertapUserProfilePush = (userDataObj = {}) => {
  if (typeof window !== 'undefined' && window.clevertap) {
    const clevertapEventObj = clevertapFilterMethod(userDataObj);
    window.clevertap.profile.push({
      Site: clevertapEventObj
    });
  }
};

const pushEvent = (event = '', trackObject = {}) => {
  let clevertapEventObj = {
    ...clevertapObj.peopleProperties,
    ...clevertapObj.superProperties,
    ...trackObject
  };
  // clevertapEventObj[ MIXPANEL_REGISTRING_COUNTRY ] = getCookie("country");
  const urlParams = getUrlParamsAsObject(window.location.search.substring(1));
  if (urlParams && urlParams.utm_source) {
    clevertapEventObj.utm_source = urlParams.utm_source;
  }
  if (urlParams && urlParams.utm_medium) {
    clevertapEventObj.utm_medium = urlParams.utm_medium;
  }
  if (urlParams && urlParams.utm_campaign) {
    clevertapEventObj.utm_campaign = urlParams.utm_campaign;
  }
  if (urlParams && urlParams.utm_content) {
    clevertapEventObj.utm_content = urlParams.utm_content;
  }
  if (urlParams && urlParams.utm_term) {
    clevertapEventObj.utm_term = urlParams.utm_term;
  }
  clevertapEventObj = clevertapFilterMethod(clevertapEventObj);
  window.clevertap.event.push(event, clevertapEventObj);
};

// Keeping CT events into queue until ckevertap is available
export const clevertapEventPush = (event = '', trackObject = {}) => {
  /* Appending super properties and people properties with custom properties */
  if (
    typeof window !== 'undefined' &&
    window.clevertap &&
    clevertapObj &&
    clevertapObj.superProperties
  ) {
    if (clevertapEventQueue && clevertapEventQueue.length) {
      clevertapEventQueue.forEach((item) => {
        pushEvent(item.event, item.trackObject);
      });
      clevertapEventQueue = [];
    }
    pushEvent(event, trackObject);
  } else {
    clevertapEventQueue.push({ event, trackObject });
  }
};

export const clevertapsubscriptionPropertySetter = (userDataObj = {}) => {
  if (typeof window !== 'undefined' && window.clevertap) {
    const clevertapEventObj = clevertapFilterMethod(userDataObj);
    window.clevertap.profile.push({
      Site: clevertapEventObj
    });
  }
};
